<template>
  <div class="app-container">
    <!-- 搜索和筛选区域 -->
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="课程名称"
        style="width: 200px"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select
        v-model="listQuery.level"
        placeholder="课程等级"
        clearable
        style="width: 120px"
        class="filter-item"
      >
        <el-option
          v-for="item in levelOptions"
          :key="item"
          :label="item"
          :value="item"
        />
      </el-select>
      <el-select
        v-model="listQuery.categoryId"
        placeholder="课程分类"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option
          v-for="item in categoryOptions"
          :key="item._id"
          :label="item.tag"
          :value="item.tag"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >
        搜索
      </el-button>
      <el-button
        class="filter-item"
        icon="el-icon-refresh"
        @click="resetFilter"
      >
        重置
      </el-button>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        添加课程
      </el-button>
    </div>

    <!-- 课程列表表格 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column label="ID" prop="id" align="center">
        <template slot-scope="{row}">
          <span>{{ row._id }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="封面" align="center">
        <template slot-scope="{row}">
          <el-image
            style="width: 80px; height: 60px"
            :src="imageUrl + row.cover"
            fit="cover"
            :preview-src-list="[imageUrl+row.cover]"
          ></el-image>
        </template>
      </el-table-column>
      
      <el-table-column label="课程名称" >
        <template slot-scope="{row}">
          <span>{{ row.name }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="教师"  align="center">
        <template slot-scope="{row}">
          <span>{{ row.teacher }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="分类"  align="center">
        <template slot-scope="{row}">
          <el-tag type="info">
            {{ row.categoryId }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="等级" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.level | levelFilter">
            {{ row.level }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="价格"  align="center">
        <template slot-scope="{row}">
          <span style="color: #ff6b6b; font-weight: bold">¥{{ row.price }}</span>
          <span v-if="row.originalPrice" style="text-decoration: line-through; color: #999; margin-left: 5px">¥{{ row.originalPrice }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="标签" >
        <template slot-scope="{row}">
          <el-tag
            v-for="tag in row.tags"
            :key="tag"
            size="mini"
            style="margin-right: 5px; margin-bottom: 5px"
          >
            {{ tag }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="{row}">
          <el-button
            type="primary"
            size="mini"
            @click="handleUpdate(row)"
          >
            编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      v-show="total>0"
      :total="total"
      :current-page.sync="listQuery.page"
      :page-size.sync="listQuery.limit"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="margin-top: 20px;"
    />

    <!-- 添加/编辑课程对话框 -->
    <el-dialog 
      :title="textMap[dialogStatus]" 
      :visible.sync="dialogFormVisible"
      width="80%"
      top="5vh"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="100px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="课程名称" prop="name">
              <el-input v-model="temp.name" />
            </el-form-item>
            
            <el-form-item label="教师" prop="teacher">
              <el-input v-model="temp.teacher" />
            </el-form-item>
            
            <el-form-item label="课程分类" prop="categoryId">
              <el-select v-model="temp.categoryId" class="filter-item" placeholder="请选择分类">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item._id"
                  :label="item.tag"
                  :value="item.tag"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="课程等级" prop="level">
              <el-select v-model="temp.level" class="filter-item" placeholder="请选择">
                <el-option
                  v-for="item in levelOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="封面图片" prop="cover">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="handleThumbnailChange"
          :before-upload="beforeAvatarUpload"
              >
                <!-- <img v-if="temp.cover" :src="temp.cover" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                <img 
              v-if="temp.cover" 
              :src="isLocalPath(temp.cover) ? temp.cover : imageUrl + temp.cover" 
              class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            
            <el-form-item label="现价" prop="price">
              <el-input-number v-model="temp.price" :min="0" :step="10" />
            </el-form-item>
            
            <el-form-item label="原价">
              <el-input-number v-model="temp.originalPrice" :min="0" :step="10" />
            </el-form-item>
            
            <el-form-item label="课程标签">
              <el-tag
                v-for="tag in temp.tags"
                :key="tag"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
              <el-input
                v-if="inputVisible"
                ref="saveTagInput"
                v-model="inputValue"
                class="input-new-tag"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              />
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-tabs v-model="activeTab">
              <el-tab-pane label="课程介绍" name="introduction">
                <el-form-item prop="introduction">
                  <el-input
                    v-model="temp.introduction"
                    type="textarea"
                    :rows="8"
                    placeholder="请输入课程介绍，支持HTML格式"
                  />
                </el-form-item>
              </el-tab-pane>
              
              <el-tab-pane label="课程大纲" name="outline">
                <div v-for="(item, index) in temp.outline" :key="index" class="outline-item">
                  <el-row :gutter="10">
                    <el-col :span="12" style="margin-bottom: 10px;">
                      <el-input v-model="item.name" placeholder="章节名称" />
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 10px;">
                      <el-input-number v-model="item.duration" :min="1" :step="1" placeholder="课时" />
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 10px;">
                      <el-input v-model="item.description" placeholder="章节描述" />
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        @click="removeOutline(index)"
                      />
                    </el-col>
                  </el-row>
                </div>
                <el-button
                  style="margin-top: 10px"
                  size="small"
                  type="primary"
                  icon="el-icon-plus"
                  @click="addOutline"
                >
                  添加章节
                </el-button>
              </el-tab-pane>
              
              <el-tab-pane label="常见问题" name="faq">
                <div v-for="(item, index) in temp.faq" :key="index" class="faq-item">
                  <el-row :gutter="10">
                    <el-col :span="11">
                      <el-input v-model="item.question" placeholder="问题" />
                    </el-col>
                    <el-col :span="11">
                      <el-input v-model="item.answer" placeholder="答案" />
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        @click="removeFaq(index)"
                      />
                    </el-col>
                  </el-row>
                </div>
                <el-button
                  style="margin-top: 10px"
                  size="small"
                  type="primary"
                  icon="el-icon-plus"
                  @click="addFaq"
                >
                  添加问题
                </el-button>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MallPage',
  filters: {
    levelFilter(level) {
      const levelMap = {
        '初级': 'success',
        '中级': 'warning',
        '高级': 'danger'
      }
      return levelMap[level]
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        name: undefined,
        level: undefined,
        categoryId: undefined
      },
      levelOptions: ['初级', '中级', '高级'],
      categoryOptions: [
       
      ],
      temp: {
        id: undefined,
        name: '',
        teacher: '',
        level: '初级',
        cover: '',
        price: 0,
        originalPrice: 0,
        tags: [],
        introduction: '',
        outline: [],
        faq: [],
        categoryId: undefined
      },
      coverFile: null,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑课程',
        create: '添加课程'
      },
      rules: {
        name: [{ required: true, message: '课程名称不能为空', trigger: 'blur' }],
        teacher: [{ required: true, message: '教师不能为空', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择课程分类', trigger: 'change' }],
        level: [{ required: true, message: '请选择课程等级', trigger: 'change' }],
        price: [{ required: true, message: '价格不能为空', trigger: 'blur' }],
        introduction: [{ required: true, message: '课程介绍不能为空', trigger: 'blur' }]
      },
      inputVisible: false,
      inputValue: '',
      activeTab: 'introduction',
     
    }
  },
  created() {
    this.getList()
    this.getCourseTags()
  },
  methods: {
    handleSizeChange(val) {
    this.listQuery.limit = val
    this.getList()
  },
  handleCurrentChange(val) {
    this.listQuery.page = val
    this.getList()
  },
    isLocalPath(url) {
    return url.startsWith('data:') || url.startsWith('blob:');
  },
    // 获取课程列表
    // getList() {
    //   this.listLoading = true
    //   const params= {
    //        page: this.listQuery.page,
    //        pageSize: this.listQuery.limit,
    //        name: this.listQuery.name,
    //        level: this.listQuery.level,
    //        categoryId: this.listQuery.categoryId
    //      }
    //   this.$http.get('/api/courses',{params}).then(response => {
        
    //     this.list = response.data.data.list
    //     this.total = response.data.total
    //   }).catch(error => {
    //     console.error('获取课程列表失败:', error)
    //     this.$message.error('获取课程列表失败')
    //   }).finally(() => {
    //     this.listLoading = false
    //   })
    // },
    getList() {
  this.listLoading = true;
  const params = {
    page: this.listQuery.page,
    pageSize: this.listQuery.limit,
    name: this.listQuery.name,
    level: this.listQuery.level,
    categoryId: this.listQuery.categoryId
  };
  
  this.$http.get('/api/courses', {params}).then(response => {
    this.list = response.data.data.list;
    // 确保total是从正确的位置获取
    this.total = response.data.data.total || response.data.total || 0;
  }).catch(error => {
    console.error('获取课程列表失败:', error);
    this.$message.error('获取课程列表失败');
  }).finally(() => {
    this.listLoading = false;
  });
},

    // 课程分类
    
    getCourseTags(){
      this.$http.get('/api/coursetags')
      .then(response => {
      console.log('课程分类',response.data.data.list)
      this.categoryOptions = response.data.data.list
      }).catch(error => {
        console.error('获取课程分类失败:', error)
        this.$message.error('获取课程分类失败')
      })
    },


     // 缩略图选择变化
     handleThumbnailChange(file) {
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.raw.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      
      this.coverFile = file.raw;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.temp.cover = e.target.result;
      };
      reader.readAsDataURL(file.raw);
      return false;
    },
    
    // 图片上传前校验
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isJPG && isLt5M;
    },
    
    // 上传单个图片
    async uploadImage(file) {
      const formData = new FormData();
      formData.append('file', file);
      
      try {
        const response = await this.$http.post('/api/courses/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (response.data.code === 200) {
          return response.data.data.url;
        } else {
          throw new Error(response.data.message || '上传失败');
        }
      } catch (error) {
        console.error('上传图片失败:', error);
        this.$message.error('上传图片失败');
        throw error;
      }
    },
    
    // 搜索课程
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    
    // 重置搜索条件
    resetFilter() {
      this.listQuery = {
        page: 1,
        limit: 10,
        name: undefined,
        level: undefined,
        categoryId: undefined
      }
      this.getList()
    },
    
    // 重置表单
    resetTemp() {
      this.temp = {
        id: undefined,
        name: '',
        teacher: '',
        level: '初级',
        cover: '',
        price: 0,
        originalPrice: 0,
        tags: [],
        introduction: '',
        outline: [],
        faq: [],
        categoryId: undefined
      }
    },
    
    // 打开创建课程对话框
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    
    // 打开编辑课程对话框
    handleUpdate(row) {
      
      this.$http({
        url: `/api/courses/${row._id}`,
        method: 'get'
      }).then(response => {
        console.log('编辑',response.data)
        this.temp = Object.assign({}, response.data.data)
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch(error => {
        console.error('获取课程详情失败:', error)
        this.$message.error('获取课程详情失败')
      })
    },
    
   // 创建课程
createData() {
  this.$refs['dataForm'].validate(async valid => {
    if (valid) {
      this.listLoading = true;
      try {
        // 如果有上传封面图片，先上传
        if (this.coverFile) {
          try {
            this.temp.cover = await this.uploadImage(this.coverFile);
          } catch (uploadError) {
            console.error('封面图片上传失败:', uploadError);
            this.$message.error('封面图片上传失败');
            return;
          }
        }
        
        // 确保所有必填字段都有值
        const courseData = {
          name: this.temp.name,
          teacher: this.temp.teacher,
          categoryId: this.temp.categoryId,
          level: this.temp.level || '初级', // 默认值
          cover: this.temp.cover || '',
          price: this.temp.price || 0,
          originalPrice: this.temp.originalPrice || 0,
          tags: this.temp.tags || [],
          introduction: this.temp.introduction,
          outline: this.temp.outline || [],
          faq: this.temp.faq || []
        };
        
        // 检查必填字段
        if (!courseData.name || !courseData.teacher || !courseData.categoryId || 
            !courseData.price || !courseData.introduction) {
          this.$message.error('请填写所有必填字段');
          return;
        }
        
        // 发送创建请求
        const response = await this.$http.post('/api/courses', courseData);
        
        if (response.data.code === 201) {
          this.$message.success('课程创建成功');
          this.getList();
          this.dialogFormVisible = false;
        } else {
          throw new Error(response.data.message || '创建失败');
        }
      } catch (error) {
        console.error('创建课程失败:', error);
        this.$message.error(error.message || '创建课程失败');
      } finally {
        this.listLoading = false;
      }
    }
  });
},

// 更新课程
updateData() {
  this.$refs['dataForm'].validate(async valid => {
    if (valid) {
      this.listLoading = true;
      try {
        // 如果有上传封面图片，先上传
        if (this.coverFile) {
          try {
            this.temp.cover = await this.uploadImage(this.coverFile);
          } catch (uploadError) {
            console.error('封面图片上传失败:', uploadError);
            this.$message.error('封面图片上传失败');
            return;
          }
        }
        
        // 准备课程数据
        const courseData = {
          name: this.temp.name,
          teacher: this.temp.teacher,
          categoryId: this.temp.categoryId,
          level: this.temp.level || '初级',
          cover: this.temp.cover || '',
          price: this.temp.price || 0,
          originalPrice: this.temp.originalPrice || 0,
          tags: this.temp.tags || [],
          introduction: this.temp.introduction,
          outline: this.temp.outline || [],
          faq: this.temp.faq || []
        };
        
        // 检查必填字段
        const requiredFields = ['name', 'teacher', 'categoryId', 'price', 'introduction'];
        const missingFields = requiredFields.filter(field => !courseData[field]);
        
        if (missingFields.length > 0) {
          this.$message.error(`以下字段为必填项: ${missingFields.join(', ')}`);
          return;
        }
        
        // 使用 this.temp._id 而不是 this.temp.id
        const response = await this.$http.put(`/api/courses/${this.temp._id}`, courseData);
        
        if (response.data.code === 200) {
          this.$message.success('课程更新成功');
          this.getList();
          this.dialogFormVisible = false;
        } else {
          throw new Error(response.data.message || '更新失败');
        }
      } catch (error) {
        console.error('更新课程失败:', error);
        this.$message.error(error.message || '更新课程失败');
      } finally {
        this.listLoading = false;
      }
    }
  });
},
    
    // 删除课程
    handleDelete(row) {
      
      this.$confirm('确定要删除该课程吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/api/courses/${row._id}`,
          method: 'delete'
        }).then(() => {
          this.getList()
          this.$message.success('删除成功!')
        }).catch(error => {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    

    

    
    // 标签相关方法
    handleClose(tag) {
      this.temp.tags.splice(this.temp.tags.indexOf(tag), 1)
    },
    
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.temp.tags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    
    // 大纲相关方法
    addOutline() {
      this.temp.outline.push({
        name: '',
        duration: 1,
        description: ''
      })
    },
    
    removeOutline(index) {
      this.temp.outline.splice(index, 1)
    },
    
    // FAQ相关方法
    addFaq() {
      this.temp.faq.push({
        question: '',
        answer: ''
      })
    },
    
    removeFaq(index) {
      this.temp.faq.splice(index, 1)
    },
    
    // 获取分类名称
    // getCategoryName(categoryId) {
    //   const category = this.categoryOptions.find(item => item.id === categoryId)
    //   return category ? category.name : '未分类'
    // }
  }
}
</script>

<style scoped>
.app-container {
  padding: 15px;
}

/* 响应式筛选区域 */
.filter-container {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-item {
  margin-right: 0 !important; /* 使用gap替代margin-right */
}

/* 表格响应式 */
.el-table {
  overflow-x: auto;
}

/* 对话框响应式 */
.el-dialog {
  max-width: 95%;
}

.el-dialog__body {
  padding: 15px 20px;
}

/* 表单布局响应式 */
@media (max-width: 992px) {
  .el-col {
    width: 100%;
  }
  
  .el-col-12 {
    max-width: 100%;
    flex: 0 0 100%;
  }
  
  .el-dialog {
    width: 95% !important;
  }
}

/* 小屏幕下的调整 */
@media (max-width: 768px) {
  .app-container {
    padding: 10px;
  }
  
  .filter-container > * {
    width: 100%;
  }
  
  .el-input, .el-select {
    width: 100% !important;
  }
  
  .el-button {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .el-table__body-wrapper {
    overflow-x: auto;
  }
  
  .el-table td, .el-table th {
    padding: 8px 0;
  }
  
  .avatar-uploader .el-upload {
    width: 120px;
    height: 120px;
  }
  
  .avatar-uploader-icon {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }
  
  .avatar {
    width: 120px;
    height: 120px;
  }
}

/* 超小屏幕下的调整 */
@media (max-width: 480px) {
  .el-dialog {
    top: 10px !important;
    margin-bottom: 10px !important;
  }
  
  .el-form-item__label {
    text-align: left;
    float: none;
    display: block;
    width: 100% !important;
    margin-bottom: 5px;
  }
  
  .el-form-item__content {
    margin-left: 0 !important;
  }
  
  .el-tabs__nav {
    white-space: normal;
  }
  
  .el-tabs__item {
    padding: 0 10px;
  }
}

/* 通用样式 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.outline-item, .faq-item {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}

/* 表格操作按钮在小屏幕下的调整 */
@media (max-width: 576px) {
  .small-padding.fixed-width .el-button {
    margin-bottom: 5px;
    display: block;
    width: 100%;
  }
  
  .small-padding.fixed-width .el-button + .el-button {
    margin-left: 0;
  }
}
</style>